<template>
  <article>
    <v-header></v-header>
    <header-search :proshows="false" :licolors="title"></header-search>
    <div id="successcasebox">
      <div class="recommend">
        <div class="recommendbt">
          <div class="recommendbtlf">
            <img class="img" src="../assets/item11.png" alt />
          </div>
          <div class="recommendbtrt">
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
          </div>
        </div>
        <div class="recommendbt">
          <div class="recommendbtrt2">
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
          </div>
          <div class="recommendbtlf">
            <img class="img" src="../assets/item11.png" alt />
          </div>
          <div class="recommendbtrt2">
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
          </div>
        </div>
        <div class="recommendbt">
          <div class="recommendbtrt">
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
            <div class="topic">
              <img src="../assets/item11.png" alt />
            </div>
          </div>
          <div class="recommendbtlf">
            <img class="img" src="../assets/item11.png" alt />
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </article>
</template>
<script>
import footer from "./footer";
import header from "./header";
import headersearch from "./headersearch";
export default {
  components: {
    "v-footer": footer,
    "v-header": header,
    "header-search": headersearch
  },
  data() {
    return {
      title: "成功案例",
      successdata: []
      // list: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
    };
  },
  created() {
    this.rqhotprodata();
    // this.list = this.oneArrToTwoArr(this.list);
    // console.log(this.list);
  },

  methods: {
    rqhotprodata(key = null) {
      this.$http.getTagProduct({ limit: 8, page: 1, kind: 3 }).then(res => {
        if (res.code == 200) {
          this.successdata = this.oneArrToTwoArr(res.data);
          console.log(this.successdata);
        } else {
          console.log(res.msg);
        }
      });
    },
    transferParameters(index) {
      let pid = `pid${index}`;
      // console.log(this.hotprodata[index]);
      // localStorage.setItem(pid, JSON.stringify(this.hotprodata[index]));
      this.$router.push({
        path: "detail",
        query: {
          detail: this.hotprodata[index].id
          //通过query 传递参数
        }
      });
    },
    oneArrToTwoArr(data) {
      var newData = [];
      for (var i = 0; i < Math.ceil(data.length / 5); i++) {
        newData[i] = [];
        for (var j = 0; j < 5; j++) {
          if (data[i * 5 + j] != undefined) {
            newData[i].push(data[i * 5 + j]);
          }
        }
      }
      return newData;
    }
  }
};
</script>
<style lang="scss" scoped>
#successcasebox {
  width: 1200px;
  margin: 30px auto 0px auto;
}
.recommendbt {
  margin-top: 10px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.recommendbtlf {
  width: 592px;
  height: 592px;
  background: rgba(255, 255, 255, 1);
}

.img {
  width: 575px;
  height: 575px;
}

.recommendbtrt2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 288px;
  height: 592px;
}
.recommendbtrt2 .topic {
  width: 288px;
  height: 288px;
  background: #ffffff;
  margin-bottom: 16px;
}
.recommend img {
  margin: 8px;
}
.recommendbtrt {
  width: 608px;
  height: 592px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.recommendbtrt .topic {
  width: 288px;
  height: 288px;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 16px;
}
.topic img {
  width: 272px;
  height: 272px;
  margin: 8px;
}
</style>
